import servise from '@/router/axios'

// 分页查询渠道列表
export const getChannelPage = (params) => {
  return servise({
    url: '/ocpx/channel/page',
    method: 'get',
    params
  })
}

// 根据 ID 查询渠道详情
export const getChannelById = (id) => {
  return servise({
    url: `/ocpx/channel/${id}`,
    method: 'get'
  })
}

// 新增渠道
export const addChannel = (data) => {
  return servise({
    url: '/ocpx/channel',
    method: 'post',
    data
  })
}

// 更新渠道
export const updateChannel = (data) => {
  return servise({
    url: '/ocpx/channel',
    method: 'put',
    data
  })
}

// 删除渠道
export const deleteChannel = (id) => {
  return servise({
    url: `/ocpx/channel/${id}`,
    method: 'delete'
  })
}

// 更新渠道状态
export const updateChannelStatus = (id, status) => {
  return servise({
    url: `/ocpx/channel/${id}/status/${status}`,
    method: 'put'
  })
}

// 查询所有启用的渠道
export const getEnabledChannelList = () => {
  return servise({
    url: '/ocpx/channel/enabled/list',
    method: 'get'
  })
}

// 生成监测 URL
export const generateMonitorUrl = (channelId, params) => {
  return servise({
    url: `/ocpx/channel/${channelId}/monitor-url`,
    method: 'get',
    params
  })
}
